import { SVGProps } from "react";

const HourglassIcon = ({
  width = 20,
  height = 20,
  color = "#EA8C00",
  ...props
}: SVGProps<SVGSVGElement> & { color?: string }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g transform="translate(2.0833 0.8333)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0.833333C0 0.373096 0.373096 0 0.833333 0H15C15.4602 0 15.8333 0.373096 15.8333 0.833333C15.8333 1.29357 15.4602 1.66667 15 1.66667H0.833333C0.373096 1.66667 0 1.29357 0 0.833333Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 17.5C0 17.0398 0.373096 16.6667 0.833333 16.6667H15C15.4602 16.6667 15.8333 17.0398 15.8333 17.5C15.8333 17.9602 15.4602 18.3333 15 18.3333H0.833333C0.373096 18.3333 0 17.9602 0 17.5Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.53107 16.6667H12.3021C11.7898 14.4444 11.1625 12.8064 10.4471 11.7059C9.64222 10.4676 8.79524 10.0008 7.9159 10C7.03735 9.99918 6.19098 10.4643 5.38622 11.7024C4.67084 12.803 4.04337 14.4421 3.53107 16.6667ZM3.98881 10.7941C4.9896 9.25442 6.29599 8.33182 7.91745 8.33333C9.53811 8.33485 10.8439 9.25814 11.8445 10.7976C12.8317 12.3163 13.5868 14.5193 14.1505 17.3365C14.1995 17.5813 14.1361 17.8352 13.9778 18.0283C13.8195 18.2214 13.583 18.3333 13.3333 18.3333H2.50001C2.25036 18.3333 2.01386 18.2214 1.85558 18.0283C1.69729 17.8353 1.6339 17.5814 1.68284 17.3366C2.24651 14.5172 3.00156 12.3129 3.98881 10.7941Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.85553 0.305036C2.01382 0.111947 2.25033 0 2.50001 0H13.3333C13.583 0 13.8195 0.111926 13.9778 0.304984C14.1361 0.498043 14.1994 0.751894 14.1505 0.9967C13.5868 3.81616 12.8318 6.02039 11.8445 7.53923C10.8438 9.07891 9.53735 10.0015 7.9159 10C6.29524 9.99849 4.98945 9.0752 3.98881 7.53575C3.00163 6.01701 2.24656 3.81406 1.68287 0.996831C1.63389 0.75201 1.69725 0.498125 1.85553 0.305036ZM3.53126 1.66667C4.0435 3.88891 4.67088 5.52693 5.38622 6.62744C6.19113 7.86576 7.03811 8.33251 7.91745 8.33333C8.79599 8.33415 9.64237 7.86903 10.4471 6.63092C11.1625 5.53034 11.79 3.89121 12.3023 1.66667H3.53126Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.83333 5.41667C5.83333 4.95643 6.20643 4.58333 6.66667 4.58333H9.16667C9.6269 4.58333 10 4.95643 10 5.41667C10 5.8769 9.6269 6.25 9.16667 6.25H6.66667C6.20643 6.25 5.83333 5.8769 5.83333 5.41667Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 15C5 14.5398 5.3731 14.1667 5.83333 14.1667H10C10.4602 14.1667 10.8333 14.5398 10.8333 15C10.8333 15.4602 10.4602 15.8333 10 15.8333H5.83333C5.3731 15.8333 5 15.4602 5 15Z"
        fill={color}
      />
    </g>
  </svg>
);

export default HourglassIcon;
